import { FC, ReactNode } from 'react';
import ModelIcon from '../model-icon';
import { Box, Stack } from '@mui/material';
import Text from '../text';

interface Props {
  name: ReactNode;
  modelId: string;
  showModelId?: boolean;
}

const ModelOption: FC<Props> = ({ name, modelId, showModelId = false }) => {
  return (
    <Stack direction="row" gap={1} alignItems="center" width="100%">
      <ModelIcon modelId={modelId} size="small" />
      <Box flexGrow={1}>
        <Stack>
          <Text>{name}</Text>
          {showModelId && (
            <Text color="grey" size="small" dotdot>
              {modelId}
            </Text>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};

export default ModelOption;
